import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';
import { DownloadInstructionsComponent } from '../download-instructions/download-instructions.component';
import { BookService } from 'src/app/services/book.service';
import { environment } from 'src/environments/environment';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-share-study',
  templateUrl: './share-study.component.html',
  styleUrls: ['./share-study.component.css']
})
export class ShareStudyComponent implements OnInit {

  @Input() opened = false;
  mail: string = '';

  //@Input() mail!: string;
  @Output('sendMail') sendMailEmitter = new EventEmitter<string>();
  @Output('downloadReport') downloadEmitter = new EventEmitter<void>();


  showMail: boolean = false;
  showQR: boolean = false;

  urlBook = window.location.href;

  urlBase: string = window.location.protocol + "//" + window.location.hostname
  urlReadable: string = (environment.demo) ? 'portal.memorial.com' : window.location.hostname

  locator?: string

  environment = environment;

  constructor(
    private alertService: AlertService,
    public bookService: BookService,
    public configService: ConfigService) { }

  ngOnInit(): void {
  }

  open(locator: string) {
    this.mail = '';
    this.locator = locator;
    this.opened = true;
  }

  close() {
    this.showMail = false;
    this.showQR = false;

    this.opened = false;
  }

  sendMail() {
    if (this.mail == null || this.mail.trim() == '') {
      this.alertService.alert('Por favor, introduzca un correo electrónico');
    } else {
      this.sendMailEmitter.emit(this.mail);
      this.close();
    }
  }


  showMailInput() {
    if (this.showMail == true) {
      this.showMail = false;
    } else {
      this.showMail = true;
      this.showQR = false;
    }
  }

  showQRImg() {
    if (this.showQR == true) {
      this.showQR = false;
    } else {
      this.showQR = true;
      this.showMail = false;
    }
  }

  downloadStudy() {
    this.downloadEmitter.emit();
    this.close();
  }


}
